<main class="dashboard">
  <div
    id="kt_app_header"
    class="app-header pe-12 mb-2 bg-white"
    data-kt-sticky="true"
    data-kt-sticky-activate="{default: true, lg: true}"
    data-kt-sticky-name="app-header-minimize"
    data-kt-sticky-offset="{default: '200px', lg: '0'}"
    data-kt-sticky-animation="false"
  >
    <div
      class="app-container container-fluid d-flex align-items-stretch justify-content-between"
      id="kt_app_header_container"
    >
      <div class="d-flex align-items-center"></div>
      <div
        class="d-flex flex-end align-items-stretch justify-content-between"
        id="kt_app_header_wrapper"
      >
        <div class="app-navbar flex-shrink-0">
          <!-- User Menu -->
          <div
            class="app-navbar-item ms-1 ms-md-4"
            id="kt_header_user_menu_toggle"
          >
            <div
              class="d-flex align-items-center cursor-pointer symbol symbol-35px"
              data-kt-menu-trigger="{default: 'click', lg: 'hover'}"
              data-kt-menu-attach="parent"
              data-kt-menu-placement="bottom-end"
            >
              <img
                src="assets/media/avatars/user-profile-icon.jpg"
                class="rounded-3"
                alt="user"
              />
              <div class="me-1">
                <a class="text-gray-900 text-hover-primary fs-6 fw-bold p-2">{{
                  currentUser?.name || "-"
                }}</a>
              </div>
              <i
                class="d-none d-sm-block fa-solid fa-angle-down text-gray-500 pt-1"
              ></i>
            </div>
            <div
              class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-color fw-semibold py-4 fs-6 w-275px"
              data-kt-menu="true"
            >
              <div class="menu-item px-3">
                <div class="menu-content d-flex align-items-center px-3">
                  <div class="symbol symbol-50px me-5">
                    <img
                      alt="Logo"
                      src="assets/media/avatars/user-profile-icon.jpg"
                    />
                  </div>
                  <div class="d-flex flex-column">
                    <div class="fw-bold d-flex align-items-center fs-5">
                      {{ currentUser?.name || "-" }}
                      <span
                        class="badge fw-bold fs-8 px-2 py-1 ms-2"
                        [ngClass]="statusClass"
                        >{{ statusText }}</span
                      >
                    </div>
                    <a class="fw-semibold text-muted fs-7">{{
                      currentUser?.role || "-"
                    }}</a>
                    <a class="fw-semibold text-muted fs-7">{{
                      currentUser?.email || "-"
                    }}</a>
                    <a class="fw-semibold text-muted fs-7">{{
                      currentUser?.customerCode || "-"
                    }} / 
                    {{
                      currentUser?.branchName || "-"
                    }}
                  </a>
                    <a class="fw-semibold text-muted fs-7"
                      >{{ "2faAuth" | translate }}:
                      <span
                        *ngIf="
                          currentUser?.authenticatorType ==
                            twoFactorAuthStatus.Google ||
                            currentUser?.authenticatorType ==
                              twoFactorAuthStatus.Email;
                          else no2FA
                        "
                        class="badge badge-success fw-bold fs-8 px-2 py-1 ms-2"
                        >{{ "active" | translate }}</span
                      >
                      <ng-template #no2FA>
                        <span
                          class="badge badge-danger fw-bold fs-8 px-2 py-1 ms-2 cursor-pointer"
                          >{{ "deactive" | translate }}</span
                        >
                      </ng-template>
                    </a>
                  </div>
                </div>
              </div>
              <div class="menu-item px-5">
                <a
                  data-bs-toggle="modal"
                  [attr.data-bs-target]="'#logoutModal'"
                  class="menu-link px-5 cursor-pointer"
                  >{{ "signOut" | translate }}</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <header class="header mt-3">
    <section class="image-grid">
      <img
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/21fb53f4ea62b637159f7c6e1fd2e9cdb691bf869df01b48f03188b35c676169?placeholderIfAbsent=true&apiKey=83d381f3414f4eb7aab2ad418c3f45ba"
        alt="Dashboard visual 1"
        class="grid-image large-image"
      />
      <img
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/6f846bd527224d18679b6e4efd8fb096627f1b52c5d3771cef32b28f08078bfe?placeholderIfAbsent=true&apiKey=83d381f3414f4eb7aab2ad418c3f45ba"
        alt="Dashboard visual 2"
        class="grid-image"
      />
      <img
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/444e51daa71fe4becd1eb5cc3655ddd58dfb0dc5b670a4e7054053b9d95fdf9e?placeholderIfAbsent=true&apiKey=83d381f3414f4eb7aab2ad418c3f45ba"
        alt="Dashboard visual 3"
        class="grid-image"
      />
      <div class="image-column">
        <img
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/39bb6158d4f6a4f9a5ceebed6e92752926bdca9895cab34bc10720d78b5b7df2?placeholderIfAbsent=true&apiKey=83d381f3414f4eb7aab2ad418c3f45ba"
          alt="Dashboard visual 4"
          class="grid-image"
        />
        <img
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/029b593cc8336a2fccd817772759cc5765d61e4d9293473fe4a2a755f74a06a8?placeholderIfAbsent=true&apiKey=83d381f3414f4eb7aab2ad418c3f45ba"
          alt="Dashboard visual 5"
          class="grid-image"
        />
      </div>
    </section>
  </header>

  <section class="content-section">
    <article class="info-card">
      <h2 class="info-title">{{ "dashboardText" | translate }}</h2>
      <p class="info-description">
        {{ "dashboardDesc" | translate }}
      </p>
      <div class="right-arrow">
        <img
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/b4d619f632f0f007156aadd825a12feb5c356bde42f1f4311ec5800d9bba9f2f?placeholderIfAbsent=true&apiKey=83d381f3414f4eb7aab2ad418c3f45ba"
          alt="Decorative element"
          class="decorative-image"
        />
      </div>
    </article>

    <div class="quick-access-cards">
      <article class="quick-access-card bg-light-purple disabled">
        <img
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/dc6ba85eb21adbca213b8e4b99d2af36a9aea3c9d86b6c293104e64c8b1f707f?placeholderIfAbsent=true&apiKey=83d381f3414f4eb7aab2ad418c3f45ba"
          alt="Patient List icon"
          class="card-icon"
        />
        <h3 class="card-title">{{ "patientList" | translate }}</h3>
      </article>
      <article class="quick-access-card bg-light-blue disabled">
        <img
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/9d7ceaa6b0943d599cd8e1cf8ad3d5b3e3fec8272572915deb5fff6f071cb19a?placeholderIfAbsent=true&apiKey=83d381f3414f4eb7aab2ad418c3f45ba"
          alt="Devices icon"
          class="card-icon"
        />
        <h3 class="card-title">{{ "devices" | translate }}</h3>
      </article>
    </div>
  </section>

  <section class="category-grid">
    <a
      *ngFor="let category of categories"
      [href]="category.link"
      [ngClass]="{
        disabled: !isCategoryActive(category.code)
      }"
      class="category-card {{ category.bgColor }}"
    >
      <img
        [src]="category.image"
        [alt]="category.name + ' icon'"
        class="category-icon"
      />
      <h3 class="category-title">{{ category.name }}</h3>
    </a>
  </section>
</main>

<!-- Logout Modal -->
<div
  class="modal fade"
  id="logoutModal"
  tabindex="-1"
  aria-labelledby="logoutModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-2" id="logoutModalLabel">
          {{ "logout" | translate }}
        </h1>
        <button
          type="button"
          class="btn-close cursor-pointer"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body fs-4">
        {{ "logoutQuestion" | translate }}
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary cursor-pointer"
          data-bs-dismiss="modal"
        >
          {{ "no" | translate }}
        </button>
        <button
          (click)="signOut()"
          type="button"
          class="btn btn-primary cursor-pointer"
          data-bs-dismiss="modal"
        >
          {{ "yes" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
